import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "transactions-table" }
const _hoisted_2 = { class: "mb-2" }
const _hoisted_3 = { class: "h-[30px]" }
const _hoisted_4 = { class: "body" }
const _hoisted_5 = { class: "date text-xs font-semibold rounded-r-xl" }
const _hoisted_6 = { class: "date text-xs text-custom_blue px-2" }
const _hoisted_7 = { class: "date text-xs text-custom_blue px-2" }
const _hoisted_8 = { class: "date text-xs text-custom_blue px-2" }
const _hoisted_9 = { class: "date text-xs font-semibold rounded-l-xl" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("table", _hoisted_1, [
      _createElementVNode("thead", _hoisted_2, [
        _createElementVNode("tr", _hoisted_3, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tableHeaders, (header, index) => {
            return (_openBlock(), _createElementBlock("th", {
              class: "head",
              key: index
            }, _toDisplayString(header), 1))
          }), 128))
        ])
      ]),
      _createElementVNode("tbody", _hoisted_4, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.transactions, (transaction, index) => {
          return (_openBlock(), _createElementBlock("tr", {
            class: _normalizeClass(["row", index % 2 === 0 ? 'bg-gray-200' : 'bg-transparent']),
            key: index
          }, [
            _createElementVNode("td", _hoisted_5, _toDisplayString(transaction.description), 1),
            _createElementVNode("td", _hoisted_6, _toDisplayString(transaction.referenceNumber), 1),
            _createElementVNode("td", _hoisted_7, _toDisplayString(transaction.formattedTransferAmount), 1),
            _createElementVNode("td", _hoisted_8, _toDisplayString(_ctx.FormatPersianAmount(transaction.balance)), 1),
            _createElementVNode("td", _hoisted_9, _toDisplayString(_ctx.persianDate(transaction.date)), 1)
          ], 2))
        }), 128))
      ])
    ])
  ]))
}